import ContentLoading from "component/LoadingComponent/ContentLoading";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import { API_BASE_URL } from "configs/AppConfig";
import { END_POINTS } from "constants/APIConstant";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import React from "react";
import Modal from "react-bootstrap/Modal";
import { useParams } from "react-router-dom";
import useSWR from "swr";
import "./MediaDetails.scss";
import LabelLang from "component/LabelLang/label-lang";
import { useIntl } from "react-intl";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";
import ReactGA from "react-ga4";

export default function MediaDetails() {
  const intl = useIntl();

  const { id } = useParams();

  const photoList = useSWR({
    url: id ? `${END_POINTS.PHOTO_ALBUM_DETAILS}?photoAlbumId=${id}` : null,
  });

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, [id]);

  // preview
  const [imagePreview, setImagePreview] = React.useState("");
  const [show, setShow] = React.useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const options = {
    loop: false,
    center: true,
    margin: 0,
    responsiveClass: true,
    autoplay: false,
    dots: false,
    smartSpeed: 500,
    nav: true,
    items: 1,
    dir: "ltr",
  };

  const renderPhotoAlbum = () => {
    const rendering = photoList?.data?.data?.photos
      ?.filter((el) => el.image !== imagePreview)
      .map(({ image }, i) => (
        <div key={i} className="item">
          <img
            // className="w-100"
            style={{ height: "400px", objectFit: "cover" }}
            src={
              image
                ? `${API_BASE_URL}/${image}`
                : process.env.PUBLIC_URL + "/image/newsr1.jpg"
            }
            alt="ved-item"
            loading="lazy"
          />
        </div>
      ));

    return rendering;
  };

  const renderPhotosList = () => {
    const photoos =
      photoList.error ||
      photoList.isLoading ||
      photoList.data === undefined ||
      photoList.data === null
        ? []
        : photoList.data.data.photos;

    const rendering = photoos.map(({ thumbnail, image }, i) => (
      <div key={i} className="col-12 col-md-6 col-lg-4 col-xl-3">
        <div className="text-center">
          <div className="img-item position-relative">
            <img
              className="img1"
              src={
                image
                  ? `${API_BASE_URL}/${image}`
                  : process.env.PUBLIC_URL + "/image/newsr1.png"
              }
              alt="ved-item"
              style={{ objectFit: "cover" }}
              loading="lazy"
            />

            <div
              className="preview"
              onClick={() => {
                setImagePreview(image);
                handleShow();
              }}
            >
              <span>{intl.formatMessage({ id: "preview" })}</span>
              <VisibilityOutlinedIcon />
            </div>
          </div>

          {/* preview */}
          <Modal
            style={{ zIndex: "9999999999" }}
            show={show}
            onHide={handleClose}
            centered
            size="lg"
          >
            {/* <Modal.Header style={{ padding: "1rem" }} closeButton>
              <Modal.Title></Modal.Title>
            </Modal.Header> */}

            <Modal.Body style={{ padding: "1.5rem", textAlign: "center" }}>
              <OwlCarousel
                id="album-details-slider"
                className="owl-carousel owl-theme"
                {...options}
              >
                <img
                  // className="w-100"
                  style={{
                    height: "400px",
                    objectFit: "cover",
                  }}
                  src={
                    image
                      ? `${API_BASE_URL}/${imagePreview}`
                      : process.env.PUBLIC_URL + "/image/newsr1.png"
                  }
                  alt="ved-item"
                  loading="lazy"
                />
                {renderPhotoAlbum()}
              </OwlCarousel>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    ));

    return rendering;
  };

  ReactGA.initialize(END_POINTS.TRACKING_ID);

  React.useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({
      hitType: "pageview",
      page: `/mediaLanding/media/${id}`,
      title: `Media details title: ${photoList?.data?.data?.photoAlbum?.title}`,
    });
  }, [id]);

  return (
    <ContentLoading
      isLoading={
        // photoList.error ||
        photoList.isLoading
      }
    >
      <div className="media-center">
        <div className="m__title__magazine">
          <h3>
            <LabelLang
              id="title"
              defaultValue={photoList?.data?.data?.photoAlbum?.title}
              translations={
                photoList?.data?.data?.photoAlbum?.photoAlbumTranslations
              }
            />
          </h3>
        </div>

        <div className="row gy-4 gx-0 gx-md-4">
          {Object.keys(renderPhotosList()).length > 0 ? (
            renderPhotosList()
          ) : (
            <DataNotFound />
          )}
        </div>
      </div>
    </ContentLoading>
  );
}
